import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {ActivationPassword} from './components/ActivationPassword'
import {ResetPasswordActivation} from './components/ResetPasswordActivation'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='activation-password' element={<ActivationPassword />} />
      <Route path='reset-password-activation' element={<ResetPasswordActivation />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
